import { useContext } from 'react';
import { EditorCapabilitiesContext } from '../context/EditorCapabilitiesContext';
export const useEditorConfigurationKey = () => {
  const {
    editorConfigKey
  } = useContext(EditorCapabilitiesContext);
  return editorConfigKey;
};